export const isString = (val: any) => {
    if (val.includes(".")) {
      return true;
    }
    if (val.length === 1 && val === " ") {
      return false;
    }
    if (
      val[val.length - 1] === " " &&
      val[val.length - 1] !== val[val.length - 2]
    ) {
      return true;
    }
    if (
      val[val.length - 1]?.trim()?.toLowerCase() !==
        val[val.length - 1]?.trim()?.toUpperCase() ||
      val === ""
    ) {
      return true;
    }
    return false;
  };
  export const isFloat = (val: any) => {
    if (val[val.length - 1] === " " || val === "." || val.includes("-")) {
      return false;
    }
    if (val.includes(".")) {
      val = val.replace(".", "");
      // eslint-disable-next-line no-restricted-globals
      if ((!val.includes(".") && !isNaN(val?.trim())) || val === "") {
        return true;
      }
      return false;
    }
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(val?.trim()) || val === "") {
      return true;
    }
    return false;
  };
  export const isNumber = (val: any) => {
    if (/^0\d+/.test(val)) return false;
  
    if (val[val.length - 1] === " ") {
      return false;
    }
    if (val.includes(".")) {
      return false;
    }
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(val?.trim()) || val === "") {
      return true;
    }
    return false;
  };
  
  export const isValidNumber = (val: any) => {
    if (/^0\d*$/.test(val)) return false;
  
    if (val[val.length - 1] === " ") {
      return false;
    }
    if (val.includes(".")) {
      return false;
    }
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(val?.trim()) || val === "") {
      return true;
    }
    return false;
  };
  
  export const isValidInput = (value: string) => {
    if (value === "") {
      return true;
    }
    if (value.trim() === "") {
      return false; // Reject if the value is empty or only consists of whitespace
    }
  
    if (value.includes("  ") || value.includes("..")) {
      return false; // Reject if there are consecutive spaces or decimals
    }
  
    return true; // Accept the input if it meets all the conditions
  };
  
  export const isValidEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  
// At least 1 uppercase, 1 special character, and minimum 8 characters
export const isStrongPassword = (password: string) => {
  const regex = /^(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/;
  return regex.test(password);
};

  export const isQuillEmpty = (value: any) => {
    if (!value) return true;
  
    const clean = value
      .replace(/<(.|\n)*?>/g, "") // remove all HTML tags
      .trim();
  
    return clean.length === 0;
  };
  
  export function formatAEDNumber(value: number | string) {
    if (value == null || value === "") return "";
    const number = Number(value);
    if (isNaN(number)) return "";
    return new Intl.NumberFormat("en-AE", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(number);
  }